jQuery(document).ready(function($){
    const sliders = $('.nf-testimonial-slider-block__wrapper');

    if ( sliders ) {
        sliders.each(function(){
            const parent = $(this).closest('.nf-testimonial-slider-block');
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                appendArrows: parent.find('.nf-testimonial-slider-block__nav'),
                appendDots: parent.find('.nf-testimonial-slider-block__dots'),
                prevArrow: '<button><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4688 22.4375L13.8125 21.125L8.5625 15.875H25V14H8.5625L13.8438 8.71875L12.5 7.40625L4.96875 14.9375L12.4688 22.4375Z" fill="#D6E5FF"/></svg></button>',
                nextArrow: '<button><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5312 22.4375L16.1875 21.125L21.4375 15.875H5V14H21.4375L16.1562 8.71875L17.5 7.40625L25.0312 14.9375L17.5312 22.4375Z" fill="#D6E5FF"/></svg></button>'
            });
        });
    }
});